<template>
    <div v-if="!isMobile">
       <v-list three-line v-bind:class="{ list_content_scroll: contentIsScrollable }" style="margin-left: -15px; margin-right: -15px">
           <v-list-item-group>
               <template v-for="(info, index) in propecInformationList">
                   <v-list-item data-cy="info-propec-list-item" :key="id + info.id" style="cursor: default">
                       <template v-slot:default="{}">
                           <v-list-item-content class="propec-item">
                               <v-list-item-title class="font-size-lg myprovet-list-title dark-blue-color" v-text="info.title"></v-list-item-title>

                               <v-list-item-action-text v-text="info.created_at" class="font-size-sm"></v-list-item-action-text>
                           </v-list-item-content>

                           <v-list-item-action class="propec-action">
                               <v-btn small class="myprovet-btn-like-icon-sm font-size-sm dark-blue-color propec-info-list-see-more-btn text-none" depressed @click="onSeeMore(info)" :data-cy="`info-propec-list-see-more-btn-${info.id}`"> {{ tb('Ver mais') }} </v-btn>
                           </v-list-item-action>
                       </template>
                   </v-list-item>

                   <v-divider v-if="index < propecInformation.length - 1" :key="index"></v-divider>
               </template>
           </v-list-item-group>
       </v-list>
   </div>
   <div style="width:100%;margin:10px auto;height:auto;max-height:200px" class="info-slider" v-else>
           <slider ref="slider" :options="options">
                   <slideritem v-for="(info,index) in propecInformationList" :key="index" :style="styleCss">
                           <v-list-item data-cy="info-propec-list-item" :key="id + info.id" style="cursor: default">
                               <template v-slot:default="{}">
                                   <v-list-item-content class="propec-item">
                                       <v-list-item-title class="font-size-lg myprovet-list-title dark-blue-color" v-text="info.title"></v-list-item-title>

                                       <v-list-item-action-text v-text="info.created_at" class="font-size-sm"></v-list-item-action-text>
                                   </v-list-item-content>

                                   <v-list-item-action class="propec-action">
                                       <v-btn small class="myprovet-btn-like-icon-sm font-size-sm dark-blue-color propec-info-list-see-more-btn text-none" depressed @click="onSeeMore(info)" :data-cy="`info-propec-list-see-more-btn-${info.id}`"> {{ tb('Ver mais') }} </v-btn>
                                   </v-list-item-action>
                               </template>
                           </v-list-item>
                   </slideritem>
           </slider>
   </div>
</template>
<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useBannersStore } from '@/Stores/banners';
import { slider, slideritem } from 'vue-concise-slider'
import { useAppStore } from '@/Stores/app';

export default {
   components: {
       slider,
       slideritem
   },
   props: {
       id: String,
       contentIsScrollable: { default: false },
       limit: { default: null },
       propecInformation: Array,
       closeInfoPropecDialog: Boolean,
   },
   data: () => ({
       options: {
         currentPage: 0,
         infinite:2,
         slidesToScroll: 1,
         loop:true,
         autoplay:'3000'
       },
       styleCss:{'margin-right': '2%'}

   }),
   computed: {
       ...mapStores(useBranchStore, useBannersStore, useUserStore,useAppStore),
       propecInformationList() {
           if(this.propecInformation.length==1){
               this.options.infinite=0
               this.options.slidesToScroll=1
               this.options.loop=false
               this.styleCss=null
           }
           return this.limit ? this.propecInformation.slice(0, this.limit) : this.propecInformation;
       },
       isMobile(){
           return this.appStore.is_mobile
       }
   },

   methods: {
       onSeeMore(obj_propec_information) {
           window.EventBus.$emit('onOpenDetailedPropecInformationDialog', obj_propec_information, this.closeInfoPropecDialog);
       },
   },
};
</script>

<style>
.propec-action {
   align-self: end !important;
   margin-bottom: 14px !important;
}
</style>
